import cn from 'classnames';
import styles from './productItem.module.scss';
import moment from 'jalali-moment';
import {useNavigate} from 'react-router-dom';
import EmptyImg from '../../../../assets/image/shared/empty.svg';
import {PostIconTypes} from '../../../../models/post/postIconTypes';
import {getInputGroupRoute} from '../../category/utilities';

type TProductItemType = {
  post: TPost;
  icon: PostIconTypes | string;
  inputGroupType: number;
  route?: string;
};

const ProductItem = ({post, inputGroupType, route}: TProductItemType) => {
  const today = new Date();
  const dateTime = moment(moment(new Date(post.created_at)))
    .locale('fa')
    .from(today); // "a day ago"
  const navigate = useNavigate();

  return (
    <>
      <div
        className={styles.productItem}
        onClick={() => {
          navigate(
            route
              ? route
              : '/dashboard/' +
                  getInputGroupRoute[inputGroupType] +
                  '/details/' +
                  post.guid,
            {
              state: {post: post},
            },
          );
        }}
      >
        <div>
          {post?.main_image ? (
            <img
              loading="lazy"
              src={post?.main_image?.image_128}
              alt={post?.title}
            />
          ) : (
            <div className={styles['productItem__empty-img']}>
              <img src={EmptyImg} alt={post?.title} />
            </div>
          )}

          {post?.status === 'published' ? (
            <div className={styles['productItem__dateTime']}>
              <span>{dateTime}</span>
            </div>
          ) : post?.status === 'rejected' ? (
            <div className={styles['productItem__rejected']}>
              <span>تایید نشده</span>
            </div>
          ) : post?.status === 'pending' ? (
            <div className={styles['productItem__pending']}>
              <span>در انتظار تایید</span>
            </div>
          ) : (
            ''
          )}
        </div>

        <div
          className={cn(
            styles['productItem__content'],
            'd-flex flex-column pe-3 w-100',
          )}
        >
          <div className="my-2">
            <span className="color-black-1 fw-800 text-break">
              {post?.title}
            </span>
          </div>
          <div className="d-flex w-100 align-items-end flex-grow-1">
            <small className="color-gray-9 fw-lighter">
              {post?.store?.title}
            </small>
          </div>
          <div className="d-flex flex-column">
            <div>
              {post?.price_on_call ? (
                <>تماس با فروشنده</>
              ) : post?.negotiated_price ? (
                <> توافقی </>
              ) : (
                <>
                  <small className="fw-800 gray-1">
                    {Number(post?.price).toLocaleString()}{' '}
                  </small>
                  <small className="fw-500 gray-1">تومان</small>
                </>
              )}
            </div>
            <div className="pt-1 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <i className="icon-location color-gray-9"></i>
                <small className="pe-1 color-gray-1">
                  {post?.state
                    ? typeof post?.state === 'object'
                      ? post?.state?.name
                      : post?.state
                    : ''}

                  {post?.city ? (
                    typeof post?.city === 'object' ? (
                      <>، {post?.city?.name}</>
                    ) : (
                      post?.city && <>، {post?.city}</>
                    )
                  ) : (
                    ''
                  )}
                </small>
              </div>

              {post?.store && (
                <div className="d-flex align-items-center">
                  <i className="icon-Star color-gold-custom"></i>
                  <small className="color-gray-9 pe-1">
                    {post?.store?.rate}
                  </small>
                </div>
              )}
            </div>
          </div>
          {/* <div className={styles['productItem__content__category']}>
            <i className={icon}></i>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ProductItem;
